import { fetchProducts } from "../api/products";
import { useState, useEffect, useCallback } from "react";
import { PaginatedProductList } from '../api-client/'

export const useProducts = (news: boolean, page: number = 1, pageSize: number = 8) => {
    const [products, setProducts] = useState<PaginatedProductList>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProductsData = useCallback(async () => {
        setLoading(true);
        try {
            const data = await fetchProducts(news, page, pageSize);
            setProducts(data);
        } catch (error: any) {
            setError(error);
        } finally {
            setLoading(false);
        }
    }, [news, page, pageSize]);

    useEffect(() => {
        fetchProductsData();
    }, [fetchProductsData]);

    return { products, loading, error };
};
